// removed by extract-text-webpack-plugin
module.exports = {"button":"src-components-button----button-module---button---38F6g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/button/button.module.scss
// module id = 109
// module chunks = 1135276415346 95715928098905 158546737534745 199248266171276